






















import Proxyable from '@/mixins/proxyable';
import mixins from '@/utils/mixins';

import { getCurrencySymbol } from '@/utils/currency';
import { isNumber } from '@/utils/helpers';

export default mixins(Proxyable).extend({
  name: 'QuotePriceTextField',

  props: {
    exchangeRate: Number,
    currencyCode: String,
    rules: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      requiredRules: [(v: string) => isNumber(v) || 'Price is required'],

      price: 0
    };
  },

  watch: {
    internalValue() {
      this.calculatePrice();
    },
    exchangeRate() {
      this.calculatePrice();
    }
  },

  mounted() {
    this.calculatePrice();
  },

  methods: {
    priceInputHandler(price: string) {
      this.internalValue = Number(price) / this.exchangeRate;
    },

    calculatePrice() {
      this.price = Number((this.internalValue * this.exchangeRate).toFixed(2));
    },

    getCurrencySymbol
  }
});
